import whaleCry from 'shared/assets/images/whaleCry.png'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { navActions } from 'entities/NavMenu'
import { ErrorScreen } from 'shared/ui/ErrorScreen'
import { redirectToCanonicalApplication } from 'shared/config/externalLinks'

export const NotFoundPage = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(navActions.setVisible(false))
    }, [dispatch])

    return (
        <ErrorScreen
            actionText="Хорошо, отдыхай кит!"
            description="Я все обыскал, но так и не смог найти нужную тебе страничку. Попробуй начать искать с главной"
            image={whaleCry}
            imageAlt="Грустный кит"
            onAction={redirectToCanonicalApplication}
            title="404... приплыли..."
        />
    )
}
